import { map, curry, fromPairs, adjust, toPairs } from 'ramda';

// ramda cookbok, not sure I'll understand someday how it works
const mapKeys = curry((fn, obj) => fromPairs(map(adjust(fn, 0), toPairs(obj))));

export default mapKeys;
